<template>
  <div id="features">
    <!-- <h2>Simplify your team's work scheduling.</h2> -->
    <h2>{{ $t("whatsIncluded") }}</h2>
    <!-- <p>An easy-to-use scheduling tool that allows business owners, managers, and employees to plan and share their work schedules with others.</p> -->
    <div id="morefeatures-wrapper">
      <FeatureSmall
        v-for="item in items"
        :key="item"
        :title="item.title"
        :icon-name="item.iconName"
        :cs-badge="item.csBadge"
        :alt-txt="item.altTxt"
      />
    </div>
  </div>
</template>

<script>
import FeatureSmall from "@/components/main_page/FeatureSmall.vue";

export default {
  name: "MoreFeaturesListing",
  components: {
    FeatureSmall,
  },
  data() {
    return {
      items: [
        {
          title: this.$t("aWorkScheduleCalendars"),
          iconName: "responsive",
          altTxt: this.$t("supportOnAllDevices"),
        },
        {
          title: this.$t("simplifiedManagement"),
          // title: 'Flexible work time management',
          iconName: "flex",
          altTxt: this.$t("workingHoursManagement"),
        },
        {
          title: this.$t("remoteAndHybrid"),
          iconName: "remote",
          altTxt: this.$t("remoteAndHybrid"),
        },
        {
          title: this.$t("automaticReminders"),
          iconName: "push2",
          altTxt: this.$t("notifications"),
        },
        {
          title: this.$t("holidayAndTimeOffsNot"),
          iconName: "holidays",
          altTxt: this.$t("holidayAndTimeOffsNot"),
        },
        {
          title: this.$t("holidaysAndAbsence"),
          iconName: "off",
          altTxt: this.$t("holidaysAndTimeOffs"),
        },
        {
          title: this.$t("supportMulipleLocations"),
          iconName: "office",
          altTxt: this.$t("multipleLocations"),
        },
        {
          title: this.$t("supportMulipleTimezones"),
          iconName: "timezone",
          altTxt: this.$t("multipleTimezones"),
        },
        {
          title: this.$t("workTimeStatistics"),
          iconName: "chart",
          altTxt: this.$t("statistics"),
          csBadge: "true"
        },
        {
          title: this.$t("slackIntegration"),
          iconName: "slack",
          altTxt: this.$t("slackIntegration"),
        },
        {
          title: this.$t("discordIntegration"),
          iconName: "discord",
          altTxt: this.$t("discordIntegration"),
        },        
        {
          title: this.$t("teamsIntegration"),
          iconName: "teams",
          altTxt: this.$t("teamsIntegration"),
          csBadge: "true"
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#features {
  padding-top: 60px;
  margin-bottom: 60px;
  @include respond-above(md) {
    padding-top: 120px;
    margin-bottom: 0;
  }
}
#morefeatures-wrapper {
  margin-bottom: 40px;

  display: flex;
  flex-wrap: wrap;

  max-width: $maxWidth;
  margin: 0 auto;

  @include respond-above(md) {
  }
}
h2 {
  margin-bottom: 20px;
  max-width: $maxWidth - 320px;
  margin: 0 auto 48px auto;
  text-align: center;
}

p {
  max-width: $maxWidth - 320px;
  margin: 0 auto 60px auto;
  text-align: center;

  @include respond-above(md) {
    margin-bottom: 30px;
  }
}
h3 {
  text-align: center;
  padding: 18px 36px;
  width: 100%;
  background-color: $yellow;
  margin-bottom: 20px;

  @include respond-above(md) {
    max-width: 300px;
    margin: 0 auto 20px auto;
  }
}
</style>
